export type TipoView = 'super' | 'admin' | 'medico' | 'enfermeiro' | 'secretaria' | 'paciente' | 'webview';

interface ObjectId {
    id: string;
}

export class OrganizacaoSimples {
    id: string;
    nome: string;
    instituicao_publica: 'S' | 'N';
    acesso_livre_profissional: 'S' | 'N';

    constructor(org: OrganizacaoSimples) {
        this.id = org.id;
        this.nome = org.nome;
        this.instituicao_publica = org.instituicao_publica;
        this.acesso_livre_profissional = org.acesso_livre_profissional;
    }

    static create(org: {
        id: string;
        nome: string;
        instituicao_publica: 'S' | 'N';
        acesso_livre_profissional: 'S' | 'N';
    }) {
        return {
            id: org.id,
            nome: org.nome,
            instituicao_publica: org.instituicao_publica,
            acesso_livre_profissional: org.acesso_livre_profissional
        }
    }
}

export class Organizacao {
    id?: string;
    name: string;
    medicos: ObjectId[];
    subadmin: ObjectId[];
    enfermeiros: ObjectId[];
    secretarias: ObjectId[];
    pacientes: ObjectId[];
    unidades: ObjectId[];
    instituicao_publica: 'S' | 'N';
    not_create_user: 'S' | 'N';

    constructor(acesso: Organizacao) {
        this.id = acesso.id;
        this.name = acesso.name;
        this.medicos = acesso.medicos;
        this.subadmin = acesso.subadmin;
        this.enfermeiros = acesso.enfermeiros;
        this.secretarias = acesso.secretarias;
        this.pacientes = acesso.pacientes;
        this.unidades = acesso.unidades;
        this.instituicao_publica = acesso.instituicao_publica;
        this.not_create_user = acesso.not_create_user;
    }

    static create(acesso: {
        id?: string;
        name: string;
        medicos: ObjectId[];
        subadmin: ObjectId[];
        enfermeiros: ObjectId[];
        secretarias: ObjectId[];
        pacientes: ObjectId[];
        unidades: ObjectId[];
        instituicao_publica: 'S' | 'N';
        not_create_user: 'S' | 'N';
    }) {
        return {
            id: acesso.id,
            name: acesso.name,
            medicos: acesso.medicos,
            subadmin: acesso.subadmin,
            enfermeiros: acesso.enfermeiros,
            secretarias: acesso.secretarias,
            pacientes: acesso.pacientes,
            unidades: acesso.unidades,
            instituicao_publica: acesso.instituicao_publica,
            not_create_user: acesso.not_create_user,
        }
    }

    static createEmpty() {
        return {
            id: undefined,
            name: '',
            medicos: [],
            subadmin: [],
            enfermeiros: [],
            secretarias: [],
            pacientes: [],
            unidades: [],
            instituicao_publica: 'N' as 'N',
            not_create_user: 'N' as 'N',
        } as Organizacao;
    }
}
